__webpack_require__.p = "https://pickleague-videos.sgp1.cdn.digitaloceanspaces.com/static-web/";